// extracted by mini-css-extract-plugin
export var text_wrapper = "whatWeDo-module--text_wrapper--xd20L";
export var text_inner_wrapper = "whatWeDo-module--text_inner_wrapper--di4gY";
export var subtitle = "whatWeDo-module--subtitle--TbvJL";
export var star_wrapper = "whatWeDo-module--star_wrapper--CoOZ3";
export var vector_wrapper = "whatWeDo-module--vector_wrapper--sZzvM";
export var dark_section = "whatWeDo-module--dark_section--nBEpc";
export var light_section = "whatWeDo-module--light_section--5DvB0";